var cilWatch = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M349.279,16H162.721L137.949,148.116a159.7,159.7,0,0,0,0,215.768L162.721,496H349.279l24.772-132.116a159.7,159.7,0,0,0,0-215.768Zm-160,32H322.721l13,69.311a159.752,159.752,0,0,0-159.434,0ZM322.721,464H189.279l-13-69.311a159.752,159.752,0,0,0,159.434,0ZM256,384A128,128,0,1,1,384,256,128.145,128.145,0,0,1,256,384Z' class='ci-primary'/>"];

export { cilWatch };

